import script from "./goRinSyo0019.vue?vue&type=script&setup=true&lang=js"
export * from "./goRinSyo0019.vue?vue&type=script&setup=true&lang=js"

import "./goRinSyo0019.vue?vue&type=style&index=0&id=f1934f58&lang=scss"

const __exports__ = script;

export default __exports__